import { LoadingOverlay } from '@mantine/core';
import { AccountCenter } from '@mygpt/app';
import { useEffect, useState } from 'react';

import { useGPTStore } from '@/store';

const AccountPage = () => {
  const { getQuotaInfo, paymentInfo } = useGPTStore();

  const [loading, setLoading] = useState(true);

  const getInfo = async () => {
    await getQuotaInfo();
    setLoading(false);
  };

  useEffect(() => {
    getInfo();
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      <LoadingOverlay visible={loading} />
      <AccountCenter paymentInfo={paymentInfo} />
    </div>
  );
};

export default AccountPage;
